(() => {
  const productId = '2232315609191';

  const initializeFlapDiscControls = () => {
    const root = document.querySelector(`product-info[data-product-id="${productId}"]`);
    const variantData = document.getElementById('FlapDiscVariantData');
    if (!root || !variantData || root.dataset.flapDiscControlsBound === 'true') return;

    let variants = [];
    try {
      variants = JSON.parse(variantData.textContent);
    } catch (error) {
      return;
    }

    const selectedOptions = () =>
      Array.from(root.querySelectorAll('variant-selects fieldset, variant-selects select')).map((group) => {
        if (group.tagName === 'SELECT') return group.value;
        return group.querySelector('input:checked')?.value;
      });

    const selectedVariant = () => {
      const options = selectedOptions();
      if (!options.length || options.some((option) => !option)) return null;
      return variants.find((variant) => variant.options.every((option, index) => option === options[index])) || null;
    };

    const syncButton = (button, variant, compact = false) => {
      if (!button) return;
      const label = button.querySelector('.btn__text, span');
      const available = Boolean(variant?.available);

      button.disabled = !available;
      if (available) {
        button.removeAttribute('aria-disabled');
      } else {
        button.setAttribute('aria-disabled', 'true');
      }

      if (label) {
        if (!variant) {
          label.textContent = window.FoxTheme?.variantStrings?.unavailable || 'Unavailable';
        } else if (!available) {
          label.textContent = window.FoxTheme?.variantStrings?.soldOut || 'Sold out';
        } else {
          label.textContent = compact
            ? (window.FoxTheme?.variantStrings?.addToCartShort || 'Add')
            : (window.FoxTheme?.variantStrings?.addToCart || 'Add to cart');
        }
      }
    };

    const syncControls = () => {
      const variant = selectedVariant();
      const sectionId = root.dataset.section;
      const mainForm = document.getElementById(`product-form-${sectionId}`);
      const installmentForm = document.getElementById(`product-form-installment-${sectionId}`);
      const priceContainer = document.getElementById(`price-${sectionId}`);
      const inventoryContainer = document.getElementById(`Inventory-${sectionId}`);
      const inventoryStatus = inventoryContainer?.querySelector('.product__inventory');
      const inventoryText = inventoryStatus?.querySelector('.product__inventory-text');

      [mainForm, installmentForm].forEach((form) => {
        const input = form?.querySelector('input[name="id"]');
        if (!input) return;
        input.value = variant?.id || '';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      const mainButton = mainForm?.querySelector('[name="add"]');
      const stickyButton = document.querySelector(`sticky-atc-bar-minimalist [name="add"][form="product-form-${sectionId}"]`);
      syncButton(mainButton, variant, false);
      syncButton(stickyButton, variant, true);

      if (!variant && priceContainer) {
        priceContainer.textContent = 'Unavailable combination';
      }

      if (inventoryText) {
        inventoryText.textContent = !variant
          ? 'Unavailable combination'
          : variant.available
            ? 'Available in stock'
            : 'Sold out';
      }
      inventoryStatus?.classList.toggle('product__inventory--out-of-stock', !variant || !variant.available);
      inventoryStatus?.classList.toggle('product__inventory--in-stock', Boolean(variant?.available));
    };

    const scheduleSync = () => {
      [0, 250, 750, 1500].forEach((delay) => window.setTimeout(syncControls, delay));
    };

    root.addEventListener('change', (event) => {
      if (event.target.closest('variant-selects')) scheduleSync();
    });
    document.addEventListener('variant:changed', scheduleSync);

    root.dataset.flapDiscControlsBound = 'true';
    root.dataset.updateUrl = 'false';
    root.querySelector('variant-selects')?.setAttribute('data-update-url', 'false');
    syncControls();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFlapDiscControls, { once: true });
  } else {
    initializeFlapDiscControls();
  }
})();
